import React from 'react';

import EmptyInbox from 'components/Icons/EmptyInbox';

import { EmptyContainer } from './styles';

interface EmptyInboxContainerProps {
  title?: string;
  description?: string;
}

const EmptyInboxContainer: React.FunctionComponent<EmptyInboxContainerProps> = ({
  title = 'Your inbox is empty',
  description = 'You have no notifications',
}): React.ReactElement => (
  <EmptyContainer>
    <EmptyInbox />
    <h1>{title}</h1>
    <p>{description}</p>
  </EmptyContainer>
);

export default EmptyInboxContainer;
